import React from 'react';

import { Box, styled } from '@mui/system';
import { Typography } from '@mui/material';
import { FormQuestion } from '../../../../../../../Utils/Types/FormBuilder';
import ReadMore from '../../../../../../ReadMore/ReadMore';

const StyledContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export default function SectionShow({
  question,
  children,
}: {
  question: FormQuestion;
  children: React.ReactNode;
}) {
  const hasTitle = question.title && question.title.length > 0;
  const hasDescription = question.description && question.description.length > 0;

  const formSectionId = `form-section-${question.id || 'start'}`;
  return (
    <section id={formSectionId} className="form-section">
      {(hasTitle || hasDescription) && (
        <Box sx={{ mb: 2 }} component={'header'}>
          {hasTitle && (
            <Typography variant="h6" component="h2">
              {question.title}
            </Typography>
          )}
          {hasDescription && <ReadMore content={question.description} />}
        </Box>
      )}
      <StyledContent>{children}</StyledContent>
    </section>
  );
}
